import React from "react";
import "./AboutSection.css";
import carImage from "./assets/car-interior.jpeg";
import whyskc from "./assets/whyskcjapan.jpg";

const AboutSection = () => {
    return (
        <div className="about-section">
            <div className="about-content">
                <div className="mainbox">
                    <p className="mainsent">
                        We see our customers as invited guests to a party, and we are the hosts. It's our job every day to make every important aspect of the customer experience a little bit better.
                    </p>
                </div>

                <div className="row">
                    <div className="col-sm-6">
                        <div className="section">
                            <h2>Who we are?</h2>
                            <p>
                                We buy used cars first hand from Japan, after performing thorough inspection of each, not compromising on the quality and condition and to eliminate any possible chance of complaints and so our clients will be surely satisfied with our service.
                            </p>
                            <p>
                                Each and every automobile in our catalogue is bought after the cautious evaluation and examination by our selective and experienced buyers, so any automobile that we buy can easily become your foremost option. Since our first appearance into the business, we’ve been growing with fresh and original ideas, improved technologies, and solid arrangements.
                            </p>
                            <p>
                                Our customers can select cars by using our efficient search engine from our catalogue. We have sales offices around the world 24/7/365 customer service centers to assist our purchasing procedures. We are always beyond your screen to help you. We keep striving for further and complete customer satisfaction and we take great pride in providing exactly what you desire by working with thoughtful, friendly and optimistic people.
                            </p>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="about-image">
                            <img src={carImage} alt="Car Interior" />
                        </div>
                    </div>
                </div>
                <div className="intro-text">
                    <div className="section">
                        <h2>What we do:</h2>
                        <p>
                            We provide worldwide, high quality Japanese cars. We consistently have a great selection of low-priced, discounted vehicles in our inventory.
                        </p>
                        <p>
                            We have the best prices in the market because we keep our vehicles in our own storage allowing us to minimize our pricing.
                        </p>
                        <p>
                            In addition to this, we have the best car purchasers in our team who make it certain that we find, buy and provide our customers the best quality cars at the lowest possible rates from domestic car dealers, owners and Japanese auctions.
                        </p>
                        <p>
                            Once our client buys an automobile from us, we try to deliver it to the respective destination within the shortest time possible through our smooth procedures.
                        </p>
                    </div>

                    <div className="section">
                        <h2>Our Services</h2>
                        <p>
                            We value our customers very much, providing 24/7 services so they get their dream car. Always evolving and looking for more and best options for you.
                        </p>
                    </div>
                </div>

                <div className="mission-vision-section">
                    <div className="section mission-vision">
                        <h2>OUR MISSION:</h2>
                        <p>
                            To empower every individual with the freedom of mobility by providing reliable, affordable, and top-quality vehicles from Japan.
                        </p>
                    </div>
                    <div className="section mission-vision">
                        <h2>OUR VISION:</h2>
                        <p>
                            To set the global standard for trust, convenience, and customer satisfaction in the used vehicle industry while living out our motto of "Cars for Everyone".
                        </p>
                    </div>
                    <div className="section">
                        <h2 className="why-nexco-heading">WHY SKC JAPAN?</h2>
                        <div className="whyskc-image">
                            <img src={whyskc} alt="Car Interior" />
                        </div>
                        <ul className="why-nexco-list">
                            <li className="why-nexco-item">
                                <div className="icon-circle">
                                    <span className="icon">📝</span>
                                </div>
                                <div className="why-nexco-text">
                                    <strong>Transparency</strong>
                                    <p>
                                        SKC JAPAN provides you with complete vehicle histories translated into Japanese as well as English. So, even if you can't read Japanese, you can still have a thorough look into the English version of your purchased car's history.
                                    </p>
                                </div>
                            </li>
                            <li className="why-nexco-item">
                                <div className="icon-circle">
                                    <span className="icon">✅</span>
                                </div>
                                <div className="why-nexco-text">
                                    <strong>Quality</strong>
                                    <p>
                                        It's a huge concern that comes with buying a used car. We ensure each car undergoes a strict inspection for quality, minimizing concerns over high mileage. We make sure each car is rust-free, in good condition, and comes with a battery suitable for your local climate.
                                    </p>
                                </div>
                            </li>
                            <li className="why-nexco-item">
                                <div className="icon-circle">
                                    <span className="icon">🔧</span>
                                </div>
                                <div className="why-nexco-text">
                                    <strong>Parts Facility</strong>
                                    <p>
                                        We provide on-demand, genuine, affordable parts to ensure you never feel the pinch of high costs. You just need to communicate your requirements, and we will get it all for you in all capacities. We deal with both the end users and the retailers.
                                    </p>
                                </div>
                            </li>
                            <li className="why-nexco-item">
                                <div className="icon-circle">
                                    <span className="icon">➕</span>
                                </div>
                                <div className="why-nexco-text">
                                    <strong>Value Addition</strong>
                                    <p>
                                        Once you have purchased a vehicle, want to change some parts or add value? No worries! We accept on-demand value-addition orders such as installation of new tires, wheels, new batteries, and accessories such as TV, Navigation, Cameras, Drive Recorder, etc.
                                    </p>
                                </div>
                            </li>
                            <li className="why-nexco-item">
                                <div className="icon-circle">
                                    <span className="icon">🌱</span>
                                </div>
                                <div className="why-nexco-text">
                                    <strong>Eco-Testing</strong>
                                    <p>
                                        Before exporting, our vehicles undergo emissions control testing to meet local emissions standards and save you future costs and hassles.
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="section one-stop-shop">
                        <h2>WE ARE A ONE-STOP-SHOP FOR ALL YOUR NEEDS</h2>
                        <p>
                            SKC JAPAN doesn't only sell Japanese used cars, and we fulfill all your automotive demands within a budget. Our products cover:
                        </p>
                        <ul className="one-stop-list">
                            <li>New and Used Cars</li>
                            <li>Heavy Machinery</li>
                            <li>Good Condition Powerful Trucks</li>
                            <li>Auto Parts and Tires</li>
                            <li>Freight Forwarding</li>
                            <li>Direct Access to Renowned Auto Auctions</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutSection;